import { transRegion } from '@/pages/opinion/utils';
import * as echarts from 'echarts';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useIntl } from 'umi';

export default function MentionChart(props: any) {
  const { chartData, topictabList } = props
  
  const ref = useRef<HTMLDivElement>(null);
  const { formatMessage } = useIntl();

    /**
   * echarts 轴格式化
   * @param value
   * @param index
   * @returns
   */
  const echartsContent = (value: any) => {
    if (value == 0) {
      return 0
    }
    if (value >= 1000000) {
      return Math.round(value / 10000) / 100 + 'M'
    }
    if (value >= 1000) {
      return Math.round(value / 10) / 100 + 'k'
    }
    return value
  }

  const toEchartsTooltipBar = (params: any) => {
    let returnData = ''
    let indexColor = params.color
    if (params.seriesName != '') {
      let name = params.data.name
  
      returnData +=
        `   <div style="display:flex;justify-content: space-between;margin-left:2px;margin-right:2px;">
      <div style="color:rgba(0,0,0,0.65);font-size:12px;display:flex; align-items:center;">
        <span style="width:9px;height:9px;border-radius:10px;background:${indexColor};"></span>
        <span style="color:rgba(0,0,0,0.65);margin-left:5px;font-size:12px">${name}</span>
      </div>
      <div style="text-align: right;">
        <span style="font-weight: 600;color: #000;margin-left:20px;font-size:12px">
          ${echartsContent(params.value)}
        </span>
      </div>
    </div>`
    }
    return returnData;
  }

  const getData = (value: number) => {
    let mentionsTotal: any = 0
    const legend: any = []
    const chartDataFinal: any = []
    // console.log('bug2', chartData)
    
    chartData?.forEach((v: any) => {
      mentionsTotal += parseFloat(v.count)
      v.name = v.name == 'youtube_keyword' ? 'youtube' : v.name;

      let name: any = topictabList.statistics_field !== 'language' && topictabList.statistics_field !== 'region' ? v?.name : transRegion(v?.name,
        topictabList.statistics_field == 'language' ? 3 : topictabList.statistics_field == 'region' ? 1 : 3);
      let data: any = { name: name, value: v.count}
      chartDataFinal.push(data)
      legend.push(name)
    })
    if (value == 1) {
      return legend
    } else {
      return chartDataFinal
    }
  }

  const getOptions = () => {
    return {
      color: ["#376AE7",],
      xAxis: {
        type: 'category',
        position: 'bottom',
        axisLabel: {
          // fontSize: 10,
          color: '#000000',
          opacity: '0.45',
          interval: 0,
          rotate: 35,
          showMaxLabel: true,
          width: 80,
          overflow: "break",
          align: "center",
          margin: 30,
        },
        splitNumber: 1,
        axisTick: {
          alignWithLabel: true,//X轴刻度对齐
          lineStyle: {
            color: '#000000',
            opacity: '0.25',
          },
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(0, 0, 0, 0.25)'
          }
        },
        data: getData(1)
      },
      tooltip: {
        formatter: (params) => toEchartsTooltipBar(params),
        borderWidth: '0',
        backgroundColor: 'rgba(0,0,0,0)'
      },
      yAxis: {
        type: 'value'
      },
      legend: {
        bottom: "2%",
        icon: 'circle',
        itemWidth: 8,
        textStyle: {
            color: '#888888',
            fontWeight: 400,
            fontSize: '12px',
        },
      },
      grid: {
        top: '20px',
        left: '0',
        right: '0',
        bottom: '0',
        containLabel: true,
      },
      series: [
        {
          name: formatMessage({ id: 'dbi_detail_volume_of_mentions'}),
          data: getData(2),
          type: 'bar',
          barWidth: 30,//柱状图宽度
          //上方展示数字
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#444',
                  fontSize: 12
                }
              }
            }
          },
        }
      ]
    }
  }

  const handleResize = (chart) => {
    if (ref?.current) {
      chart.resize();
    }
  };

  useEffect(() => {
    let _chart;
    let listener: null | (() => void) = null;

    if (ref.current) {
      const options = getOptions();
      // canvas
      _chart = echarts.init(ref.current, undefined, { renderer: 'canvas' });
      _chart.setOption(options, { notMerge: true });
      listener = () => {
        handleResize(_chart);
      };

      window.addEventListener('resize', listener);
    }

    return () => {
      if (_chart && listener !== null) {
        window.removeEventListener('resize', listener);
        _chart.off();
      }
    };
  }, [props]);
  
  const chartStyle = {
    height: '350px',
    width: '100%',
  };

  return (
    <div style={{ ...chartStyle, textAlign: 'center' }}>
      <div ref={ref} style={chartStyle}></div>
    </div>
  );
}